import { Button } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { MockupJobs } from '../common';
import { track } from '../../analytics/track';
import { AnalyticsEvents } from '../../analytics/events';
import ApplicantCard from '../swiper/ApplicantCard';

const Columns = ({
  applicants,
  column,
  jobId,
  threshold,
  selectCallback,
  toggleColumnCallback,
  disabledMore,
  moreCallback,
  loading,
}: {
  applicants: {
    totalCount: number;
    nodes: {
      id: string;
      stage: number;
      score: number;
      status: string;
      accepted: boolean;
      createdAt: string;
      candidate: {
        id: string;
        firstName: string;
        lastName: string;
      };
      aiDetection: {
        isAi: boolean;
      };
      activityLog: {
        createdAt: string;
        actionType: string;
        actionSubType: string;
        message: string;
      }[];
    }[];
  };
  column: { id: string; title: string };
  jobId?: string;
  threshold: number;
  selectCallback: (e: { jobId?: string; applicationId: string }) => void;
  toggleColumnCallback: () => void;
  disabledMore: boolean;
  moreCallback: () => void;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const antal = applicants ? applicants.totalCount * 1 : 0;

  let colName = column.id;
  if (column.id === 'newApplicants') colName += ' fix';

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;
    const offset = 30;

    if (target.scrollTop + target.clientHeight + offset >= target.scrollHeight) {
      if (!disabledMore && !loading) moreCallback();
    }
  };

  return (
    <div className={'relative w-1/4 px-2 kanban-column col-' + colName}>
      <div className="kanban-header flex justify-between">
        <div className="flex items-center">
          <h1 className="m-0 leading-[1.2]">{applicants ? antal : 0}</h1>
          <h4 className="m-0 pl-4 leading-[1.2]">
            {column && <div dangerouslySetInnerHTML={{ __html: column.title }}></div>}
          </h4>
        </div>
        <div>
          {column.id === 'hired' || column.id === 'notHired' ? (
            <Button size="3" variant="outline" color="gray" className="float-right mt-1" onClick={toggleColumnCallback}>
              <u>{column.id === 'hired' ? t('kanban.columnToggle.notHired') : t('kanban.columnToggle.hired')}</u>
            </Button>
          ) : null}
        </div>
      </div>
      <div className={'scroll'} onScroll={handleScroll}>
        {applicants ? (
          applicants.nodes.map((application, index) => {
            return (
              <ApplicantCard
                key={`${application.id}-list-item`}
                application={application}
                index={index}
                columnId={column.id}
                selectCallback={selectCallback}
                threshold={threshold}
                jobId={jobId}
              />
            );
          })
        ) : (
          <MockupJobs />
        )}
        {!disabledMore && (
          <Button
            size="3"
            color="gray"
            variant="soft"
            loading={loading}
            className="w-full"
            onClick={() => {
              if (!loading) {
                track(AnalyticsEvents.CANDIDATES_LOAD_MORE_CLICKED, { column: String(column) });
                moreCallback();
              }
            }}
          >
            {t('kanban.loadMoreButton')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Columns;
